import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../core/table";
import { getHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import { toast } from "react-toastify";
import CustomModal from "../../core/modal";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
import DefectFilters from "./defect-filters";
import { PAGE_LIMIT } from "../../utils";
const Defects = () => {
  const navigate = useNavigate();
  const [addDefects, setAddDefects] = useState(false);
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [defects, setDefects] = useState({
    results: [],
  });
  const [filters, setFilters] = useState({
    type: "defect",
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });

  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData(filters);
    }
  }, []);
  const addDefectFormHandler = () => {
    setAddDefects(true);
  };
  const addCodeHandler = (event) => {
    setCode(event.target.value);
  };
  const addDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const payload = {
    type: "defect",
    code: code,
    description: description,
  };
  //Show All defects
  const loadData = (filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.List_CODES}`,
      null,
      filters
    )
      .then((response) => {
        if (response) {
          setDefects(response);
        }
      })
      .catch((err) => console.error(err));
  };
  //Add New defect
  const formSubmitHandler = () => {
    if (payload.code !== "" && payload.description !== "") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.CODES}defect`,
        payload,
        { active: true }
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            loadData(filters);
            setCode("");
            setDescription("");
            setAddDefects(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <>
      <div className="page-body">
        <div className="create-con">
          <div>
            <p className="tab-name">Setup</p>
            <p className="section-name">Defect Codes</p>
          </div>
          <CustomButtonComponent
            variant="contained"
            color="primary"
            onClick={addDefectFormHandler}
          >
            Add Defect Code
          </CustomButtonComponent>
        </div>

        <div className="si-hide-mobile">
          <CustomTable
            header={getHeaderConfig(loadData, filters)}
            data={defects.results || []}
            pageCount={defects.totalPages}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<DefectFilters loadData={loadData} />}
          />
        </div>
        {addDefects && (
          <CustomModal
            title="New Defect Code"
            onClose={() => setAddDefects(false)}
          >
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                fullWidth
                id="code"
                label="Code"
                sx={{ m: 1 }}
                onChange={addCodeHandler}
                value={code}
                size="small"
              />
              <TextField
                fullWidth
                id="description"
                label="Description"
                multiline
                sx={{ m: 1 }}
                rows={4}
                onChange={addDescriptionHandler}
                value={description}
                size="small"
              />
              <Stack
                direction="row"
                spacing={2}
                sx={{ m: 1, justifyContent: "flex-end" }}
              >
                <CustomButtonComponent
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setAddDefects(false);
                  }}
                >
                  Cancel
                </CustomButtonComponent>
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  onClick={formSubmitHandler}
                >
                  Save
                </CustomButtonComponent>
              </Stack>
            </Box>
          </CustomModal>
        )}
      </div>
    </>
  );
};

export default Defects;
